import {defineAbilityConfig} from '../system/defineAbilityConfig';
import {ENTITLEMENT_KEYS} from '@packages/domains/subscription-and-payments/entitlements/data-types';
import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';

// Private Hosting deploy. Two abilities so the control can be hidden entirely
// (no flag / no entitlement) but merely disabled with a tooltip when the user
// lacks the permission — the same split as canViewExportButton / canExport.
export const canViewPrivateHostingDeployButton = defineAbilityConfig({
  siteModes: {design: true},
  featureFlags: {
    [FEATURE_FLAGS.DEPLOY_BUTTON]: true,
    [FEATURE_FLAGS.PRIVATE_HOSTING_INTERNAL]: true,
  },
  // Matches the route: the control stays hidden without the site entitlement.
  entitlements: [ENTITLEMENT_KEYS.ALLOW_PRIVATE_HOSTING],
  userTypes: {
    authorizedInDesigner: true,
  },
} as const);

export const canDeployPrivateHosting = defineAbilityConfig({
  abilities: {canViewPrivateHostingDeployButton: true},
  userTypes: {
    authorizedInDesigner: true,
  },
  // Both are required, matching the route. A deploy is export-like in
  // mechanism and publish-like in consequence, and each action alone admits
  // roles the other excludes: export grants branch_designer and page_builder,
  // publish grants editor and page_builder_v2. The pair lands on
  // project_admin and designer. Decided 2026-09-15; GOV-3162 still owns
  // whether this becomes a dedicated action before GA.
  permissions: [
    ['export', 'site'],
    ['publish', 'site'],
  ],
  // Deploy ships a production artifact, so unlike canExport this is not
  // offered in edit mode.
  siteModes: {design: true},
} as const);
